module.exports = __webpack_public_path__ + "img/SINGLE EAR RING GREEN.1e30491.svg";